import { render, staticRenderFns } from "./adult_surveillances.vue?vue&type=template&id=d9d34982&"
import script from "./adult_surveillances.vue?vue&type=script&lang=js&"
export * from "./adult_surveillances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports